import React from 'react';
import { loginRequest } from "../authConfig";
import { MsalContext, IMsalContext } from "@azure/msal-react";
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';

export interface SignInOrOutButtonProps
{
    isAuthenticated: boolean;
    isInProgress: boolean;
}

export interface SignInOrOutButtonState
{
}

export class SignInOrOutButton extends React.Component<SignInOrOutButtonProps, SignInOrOutButtonState>
{
    context!: IMsalContext;
    static contextType = MsalContext;

    render()
    {
        if (this.props.isInProgress)
            return (<div>Signing in...</div>);
        else if (!this.props.isAuthenticated)
            return (<SignInButton />);
        else
            return (<div><SignOutButton/> Signed in as {this.context.accounts[0].username}</div>);
    }
}